import { useState, useEffect } from 'react';
import { buildApiUrl } from '../config/apiConfig';

// Cache em nível de módulo: todos os componentes da home compartilham UMA
// única requisição a /home-config (evita multiplicar conexões com o banco).
//
// Atualização "em tempo real": o cache tem validade (TTL). Os componentes
// re-buscam ao montar quando o cache vence e, enquanto a aba está visível,
// um poll leve traz o que o admin salvou no painel sem precisar recarregar.
// O poll pausa quando a aba fica oculta (protege o limite de conexões do
// MySQL da Hostinger).
let cache = null;
let cacheTime = 0;
let inflight = null;

const TTL = 30000; // 30s

export function fetchHomeConfig(force = false) {
  const fresco = cache && Date.now() - cacheTime < TTL;
  if (fresco && !force) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = fetch(buildApiUrl('home-config'))
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (data) {
        cache = data;
        cacheTime = Date.now();
      }
      inflight = null;
      return cache;
    })
    .catch((e) => {
      inflight = null;
      console.error('Erro ao carregar configuração da home:', e);
      return cache;
    });
  return inflight;
}

export default function useHomeConfig() {
  const [config, setConfig] = useState(cache);

  useEffect(() => {
    let mounted = true;
    const aplicar = (data) => {
      if (mounted && data) setConfig(data);
    };

    fetchHomeConfig().then(aplicar);

    // Poll só enquanto a aba está visível.
    const tick = () => {
      if (document.visibilityState === 'visible') {
        fetchHomeConfig(true).then(aplicar);
      }
    };
    const intervalo = setInterval(tick, TTL);
    // Ao voltar para a aba, atualiza na hora.
    const onVisible = () => {
      if (document.visibilityState === 'visible') fetchHomeConfig(true).then(aplicar);
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      mounted = false;
      clearInterval(intervalo);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return config;
}
